import { render, staticRenderFns } from "./NrpDotTag.vue?vue&type=template&id=419186cc&scoped=true"
import script from "./NrpDotTag.vue?vue&type=script&lang=js"
export * from "./NrpDotTag.vue?vue&type=script&lang=js"
import style0 from "./NrpDotTag.vue?vue&type=style&index=0&id=419186cc&prod&lang=less&scoped=true"
import style1 from "./NrpDotTag.vue?vue&type=style&index=1&id=419186cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419186cc",
  null
  
)

export default component.exports